/* eslint-disable import/order */
import NutanixLogoTypeLight from './images/icon-nutanix-type-light.svg';
import NutanixLogoTypeDark from './images/icon-nutanix-type-dark.svg';
import ServersIcon from './images/icon-servers.svg';
import InfoIcon from './images/icon-info.svg';
import UsersIcon from './images/icon-users.svg';
import ApplicationsIcon from './images/icon-applications.svg';
import Next from './images/icon-next.svg';
import ClusterCloud from './images/cluster-cloud.svg';
import Clusters from './images/clusters.svg';

// IDPs icons
import GoogleIcon from './images/idps/icon-google.png';
import SamlIcon from './images/idps/icon-saml.png';
import ApiGatewayIcon from './images/idps/api-gateway.svg';
import MyNutanixIcon from './images/idps/icon-my-nutanix.png';

// Cloud provider icons
import AzureIcon from './images/cloud-providers/icon-azure.svg';
import AwsIcon from './images/cloud-providers/icon-aws.svg';
import GCPIcon from './images/cloud-providers/icon-gcp.png';
import XiIcon from './images/cloud-providers/icon-xi.svg';
import VM from './images/nutanix/vm_blue.svg';

const Icons = {
  NUTANIX_TYPE_LIGHT: NutanixLogoTypeLight,
  NUTANIX_TYPE_DARK: NutanixLogoTypeDark,
  SERVERS: ServersIcon,
  INFO: InfoIcon,
  USERS: UsersIcon,
  APPLICATIONS: ApplicationsIcon,
  NEXT: Next,
  CLUSTER_CLOUD: ClusterCloud,
  CLUSTERS: Clusters,
  IDPs: {
    FRAME: MyNutanixIcon,
    GOOGLE: GoogleIcon,
    SAML: SamlIcon,
    API_GATEWAY: ApiGatewayIcon,
    MY_NUTANIX: MyNutanixIcon,
  },
  CLOUD_PROVIDERS: {
    AZURE: AzureIcon,
    AWS: AwsIcon,
    GCP: GCPIcon,
    XI: XiIcon,
  },
  NUTANIX: {
    VM,
  },
};

Object.freeze(Icons);

export default Icons;
